import React, { useCallback, useState } from "react"
import { Swiper, SwiperSlide } from "swiper/react"

import {
  Box,
  TestimonialContainer,
  VideoSliderHeader,
} from "../../styles/Components/VideoTestimonial/VideoTestimonialStyles"
import IndexMapButtons from "../IndexMapButtons/IndexMapButtons"

import VideoSlide from "./VideoSlide"

const VideoTestimonial = ({ component }) => {
  const [slideIndex, setSliderIndex] = useState(0)

  let eyebrowText = component?.eyebrow
  let mainTitle = component?.centerMainTitle
  let mainParagraph = component?.centerMainParagraph

  let videoSlideArray = component?.videoSlideArray?.map((v) => {
    let videoObj = {}

    videoObj.icon = v?.companyIcon
    videoObj.image = v?.slideImage
    videoObj.rep = v?.testimonialRep
    videoObj.mediaType = v?.imageOrVideo
    videoObj.companyName = v?.companyName
    videoObj.video = v?.video
    videoObj.testimonialQuote = v?.testimonialQuote

    return videoObj
  })

  const handleSlideIndex = useCallback((slide) => {
    setSliderIndex(slide.realIndex)
  }, [])

  return (
    <Box>
      <TestimonialContainer>
        <VideoSliderHeader>
          {eyebrowText && <small className="eyebrow">{eyebrowText}</small>}
          {mainTitle && <h2 className="container-title">{mainTitle}</h2>}
          {mainParagraph && (
            <p className="text-area text-center">{mainParagraph}</p>
          )}
        </VideoSliderHeader>
        <Swiper
          style={{ padding: "0" }}
          loop={true}
          spaceBetween={4}
          slidesPerView="auto"
          slideToClickedSlide
          centeredSlides={true}
          navigation={{
            prevEl: ".video-prev",
            nextEl: ".video-next",
          }}
          onSlideChange={(evt) => handleSlideIndex(evt)}
        >
          {videoSlideArray?.map((slide, idx) => (
            <SwiperSlide key={slide.companyName + idx}>
              <VideoSlide testimonialObject={slide} />
            </SwiperSlide>
          ))}
        </Swiper>
        <IndexMapButtons
          slideIndex={slideIndex}
          componentArray={videoSlideArray}
          dark={true}
        />
      </TestimonialContainer>
    </Box>
  )
}

export default VideoTestimonial
